import {useTranslation} from "react-i18next";

export default function useMyTranslation(dir = '')
{
    const {t} = useTranslation();

    const translator = (key, directory = dir) => {
        if(!key.startsWith(directory))
        {
            return t(directory + '.' + key);
        }

        return t(key);
    }

    return translator;
}